<template>
  <div class="ic-form__name">
    <IcFormRowWrapper
      id="sex"
      name="name.sex"
      :aria="$t('aria_required')"
      
      :labelWidth="4"
      :controlWidth="8"
    >
      <template v-slot="{validator}">
        <IcRadioGroup
          id="sex"
          v-model="data.sex"
          :options="sexOptions"
          @input="$emit('update:sex ', $event)"
          outerClass="pull-left mr-5"
        ></IcRadioGroup>        
      </template>
    </IcFormRowWrapper>

    <IcFormRowWrapper
      id="firstName"
      name="name.firstName"
      :aria="$t('aria_required')"
      :label="$t('label_firstName')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template v-slot="{validator}">
        <IcInput id="firstName" autocomplete="given-name"  v-model="data.firstName" @input="emitInput(data,validator)" :maxlength="30" capitalize="1"></IcInput>
      </template>
    </IcFormRowWrapper>

    <IcFormRowWrapper
      id="lastName"
      name="name.lastName"
      :aria="$t('aria_required')"
      :label="$t('label_lastName')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template v-slot="{validator}">
        <IcInput id="lastName" autocomplete="family-name" v-model="data.lastName" @input="emitInput(data,validator)" maxlength="50"  capitalize="1"></IcInput>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
import IcInput from "@/components/ic-common/form/controls/Input";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import { Name } from "@/components/ic/form/contact/Model/Name";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactName",
  props: {
    value: {
      type: [Object],
      default: new Name()
    }
  },
  data() {
    return {
      sexOptions: [{ id: 'M', name: "Pan" }, { id: 'F', name: "Pani" }],
      data: Object.assign({}, new Name(), this.value)
    };
  },
  computed: {
    fullname: function() {
      return `${this.data.firstName} ${this.data.lastName}`.trim();
    }
  },
  watch: {
    fullname: function() {
      this.$emit("update:fullname", this.fullname);
    }
  },
  methods: {
    emitInput
  },
  components: {
    IcInput,
    IcRadioGroup
  }
};
</script>

<style>
.mr-5 {margin-right:1rem;}
</style>
